import { ChangeDetectionStrategy, Component, OnInit, computed, input, signal } from '@angular/core';
import { ZenriseBank, ZenriseBankAccount } from '@pedix-workspace/utils';
import { TextFieldComponent } from '@pedix-workspace/angular-ui-form';
import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
import { DxValidatorModule } from 'devextreme-angular/ui/validator';
import { DxiValidationRuleModule } from 'devextreme-angular/ui/nested';
import { TranslocoDirective } from '@jsverse/transloco';
import { DOCUMENT_TYPES, getDocumentMask, stripDocumentMask } from '../zenrise/document-mask';

@Component({
  selector: 'pxw-argentine-cbu-payment',
  templateUrl: './argentine-cbu-payment.component.html',
  styleUrls: ['./argentine-cbu-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    TextFieldComponent,
    DxSelectBoxModule,
    DxValidatorModule,
    DxiValidationRuleModule,
  ],
})
export class ArgentineCbuPaymentComponent implements OnInit {
  readonly cbuModel = input.required<ZenriseBankAccount>();
  readonly banks = input<ZenriseBank[]>([]);

  readonly cbuPattern = /^\d{22}$/;
  readonly documentTypes = DOCUMENT_TYPES;
  readonly selectedDocumentType = signal('cuit');
  readonly documentMask = computed(() => getDocumentMask(this.selectedDocumentType()));
  readonly sortedBanks = computed(() => [...this.banks()].sort((a, b) => a.id - b.id));

  ngOnInit() {
    const holderId = stripDocumentMask(this.cbuModel().holderIdNumber);
    if (holderId && holderId.length <= 8) {
      this.selectedDocumentType.set('dni');
    }
  }

  onDocumentTypeChange(documentType: string) {
    if (documentType === this.selectedDocumentType()) {
      return;
    }
    this.cbuModel().holderIdNumber = '';
    this.selectedDocumentType.set(documentType);
  }
}
